// src/context/LanguageContext.jsx
import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  en: {
    // Navbar
    nav_home: "Home",
    nav_store: "Store",
    nav_how: "How to Use",
    nav_orders: "My Orders",
    nav_login: "Login",
    nav_started: "Get Started",
    nav_signout: "Sign Out",
    nav_admin: "Admin Panel",

    // Home
    hero_eyebrow: "Cambodia's #1 Game Store",
    hero_title: "Premium Games",
    hero_accent: "For Less",
    hero_sub: "Play AAA titles with shared Steam accounts. Instant delivery. Offline access. Prices starting at $2.99 USD. Pay with Bakong KHQR.",
    hero_browse: "Browse Games →",
    hero_how: "How it works",
    stat_games: "Games Available",
    stat_customers: "Happy Customers",
    stat_price: "Starting Price",
    stat_support: "Support",
    section_why: "Why Phsar Game",
    section_everything: "Everything you need",
    section_everything_sub: "Simple, fast, and affordable way to play premium games in Cambodia.",
    feat_instant: "Instant Delivery",
    feat_instant_desc: "Get your Steam credentials immediately after payment. No waiting, no delays.",
    feat_offline: "Offline Access",
    feat_offline_desc: "Play your games in Steam offline mode anytime. No internet required during gameplay.",
    feat_price: "Best Price in KH",
    feat_price_desc: "Save up to 90% compared to official Steam prices. Premium games at budget cost.",
    feat_support: "24/7 Support",
    feat_support_desc: "Stuck? Our support team is always ready via live chat to help you get started.",
    section_featured: "Featured Games",
    section_featured_tag: "Top Picks",
    section_featured_sub: "Hand-picked AAA titles at the best prices. All available for offline play.",
    view_all: "View All Games →",
    how_title: "How It Works",
    how_tag: "Simple Process",
    how_sub: "Get gaming in 4 easy steps. The whole process takes under 5 minutes.",
    step1_title: "Browse & Buy",
    step1_desc: "Pick your game and pay securely with Bakong KHQR.",
    step2_title: "Get Credentials",
    step2_desc: "Receive Steam email & password instantly after payment.",
    step3_title: "Install & Go Offline",
    step3_desc: "Login to Steam, install the game, then switch to offline mode.",
    step4_title: "Play Forever",
    step4_desc: "Launch with your own account in offline mode. No limits.",
    cta_title: "Ready to Start Gaming?",
    cta_desc: "Join hundreds of Cambodian gamers already saving money on Steam games. Pay with ABA, ACLEDA, Wing and more via KHQR.",
    cta_btn: "Browse Games Now →",
    footer_copy: "Premium Steam Shared Accounts · Cambodia Only",
    footer_note: "For offline gaming only. Not affiliated with Valve Corporation.",

    // Store
    store_title: "Game Store",
    store_sub: "games available",
    search_placeholder: "Search games...",
    sort_newest: "Newest",
    sort_price_asc: "Price ↑",
    sort_price_desc: "Price ↓",
    sort_rating: "Top Rated",
    sort_name: "A → Z",
    filter_instock: "In Stock Only",
    no_games: "No games found",
    no_games_sub: "Try adjusting your filters or search terms.",
    account_type: "Account Type",
    all_types: "All Types",

    // Game Detail
    about_game: "About This Game",
    whats_included: "What's Included",
    how_works: "How It Works",
    instant_delivery: "Instant Delivery",
    offline_access: "Offline Access",
    full_access: "Full Game Access",
    support_chat: "Support Chat",
    permanent: "Permanent Access",
    cambodia: "Cambodia Only",
    buy_now: "Buy Now →",
    out_of_stock: "Out of Stock",
    secured: "🔒 Secured by Bakong · NBC Cambodia",
    delivery_label: "Delivery",
    delivery_val: "⚡ Instant",
    type_label: "Type",
    stock_label: "Stock",
    payment_label: "Payment",
    in_stock: "✅ Available",
    back_store: "← Back to Store",

    // Orders
    orders_title: "My Orders",
    orders_all: "All",
    orders_delivered: "Delivered",
    orders_pending: "Pending",
    orders_expired: "Expired",
    no_orders: "No orders yet",
    no_orders_sub: "Browse our store and get your first game!",
    view_creds: "🔑 View Credentials",
    complete_pay: "💳 Complete Payment",
    support_chat_btn: "💬 Support Chat",
    view_game: "🎮 View Game",

    // Chat
    chat_support: "Phsar Game Support",
    chat_online: "Online",
    chat_placeholder: "Type your message...",
    chat_hint: "Press Enter to send · Shift+Enter for new line",
    chat_empty_title: "Start the conversation",
    chat_empty_sub: "Ask us anything about your order.\nWe typically reply within a few minutes.",

    // Auth
    login_title: "Welcome Back",
    login_sub: "Sign in to your Phsar Game account",
    login_email: "Email",
    login_password: "Password",
    login_btn: "Sign In",
    login_google: "Continue with Google",
    login_no_account: "Don't have an account?",
    login_register: "Register",
    register_title: "Create Account",
    register_sub: "Join Phsar Game today",
    register_name: "Display Name",
    register_btn: "Create Account",
    register_have_account: "Already have an account?",
    register_login: "Login",

    // Account types
    acc_steam: "Steam",
    acc_epic: "Epic Games",
    acc_game_account: "Game Account",
    acc_shared: "Shared Offline",
    acc_private: "Private Account",
    acc_family: "Family Share",

    // Status
    status_delivered: "Delivered",
    status_processing: "Processing",
    status_pending: "Pending",
    status_expired: "Expired",
    status_failed: "Failed",

    // Floating chat
    float_chat_title: "Live Support",
    float_chat_sub: "We reply in minutes",
    float_new_msg: "New message",

    // Checkout
    co_order_summary:   "Order Summary",
  co_total:           "Total",
  co_powered_by:      "Powered by",
  co_only:            "Only",
  co_left:            "left",
  co_available:       "available",
 
  co_secure_checkout: "Secure Checkout",
  co_scan_to_pay:     "Scan to Pay",
  co_expired_title:   "QR Code Expired",
  co_error_title:     "Payment Error",
 
  co_generating_qr:   "Generating QR Code",
  co_pay_now:         "Pay Now",
  co_secured_by:      "Secured by ABA Bank Cambodia",
 
  co_scan_with:       "Scan with",
  co_or_banking:      "or any supported banking app",
  co_amount:          "Amount",
  co_open_aba:        "Open ABA Mobile App",
 
  co_poll_waiting:    "Waiting for payment",
  co_poll_confirmed:  "Payment confirmed! Delivering credentials...",
 
  co_expired_desc:    "The QR code has expired (15 minute limit).\nGenerate a new one to continue.",
  co_new_qr:          "Generate New QR",
 
  co_generic_error:   "Something went wrong. Please try again.",
  co_try_again:       "Try Again",
  co_out_of_stock_err:"Sorry, this game just went out of stock!",
  co_unavailable:     "This game is not available.",
  co_load_fail:       "Failed to load game info.",
  co_pay_fail:        "Payment initiation failed.",
  // How to use
 // Hero
  htu_tag:          "Quick Guide",
  htu_title:        "How to",
  htu_title_accent: "Get Started",
  htu_sub:          "Follow these 7 easy steps to start playing your game in under 10 minutes.",
 
  // Step 1
  htu_s1_title: "Browse & Buy",
  htu_s1_desc:  "Go to our Store, pick any game you want, and click Buy Now.",
  htu_s1_d1:    "All games available for offline Steam access",
  htu_s1_d2:    "Prices start from $2.99 USD",
  htu_s1_d3:    "Pay securely with Bakong KHQR (ABA, ACLEDA, Wing, etc.)",
 
  // Step 2
  htu_s2_title: "Scan KHQR to Pay",
  htu_s2_desc:  "A QR code will appear. Open your banking app and scan it.",
  htu_s2_d1:    "Works with ABA, ACLEDA, Wing, True Money, Pi Pay and more",
  htu_s2_d2:    "Processed instantly by Bakong (National Bank of Cambodia)",
  htu_s2_d3:    "QR code is valid for 15 minutes",
 
  // Step 3
  htu_s3_title: "Receive Credentials",
  htu_s3_desc:  "After payment is confirmed, your Steam account details appear immediately.",
  htu_s3_d1:    "Steam Email and Password delivered on screen",
  htu_s3_d2:    "Also sent to your registered email",
  htu_s3_d3:    "Save these credentials safely!",
 
  // Step 4
  htu_s4_title: "Login to Steam",
  htu_s4_desc:  'Open Steam and click "Sign in to a different account". Enter the provided credentials.',
  htu_s4_d1:    "Download Steam from store.steampowered.com if needed",
  htu_s4_d2:    "Use the exact credentials — do not modify anything",
  htu_s4_d3:    "If Steam asks for verification, contact our support",
 
  // Step 5
  htu_s5_title: "Install the Game",
  htu_s5_desc:  "Go to your Library, find the game, and click Install.",
  htu_s5_d1:    "Make sure you have enough disk space",
  htu_s5_d2:    "Download speed depends on your connection",
  htu_s5_d3:    "You only need to install once",
 
  // Step 6
  htu_s6_title: "Switch to Offline Mode",
  htu_s6_desc:  'Go to Steam menu (top-left) → click "Go Offline". Steam will restart.',
  htu_s6_d1:    "Click Steam in the top-left corner",
  htu_s6_d2:    'Select "Go Offline…" from the dropdown',
  htu_s6_d3:    "Steam will restart — this is normal",
 
  // Step 7
  htu_s7_title: "Play!",
  htu_s7_desc:  "Launch the game from your library. Log back into your own Steam account and play offline!",
  htu_s7_d1:    "The game launches in offline mode",
  htu_s7_d2:    "Switch back to your personal Steam account",
  htu_s7_d3:    "Enjoy your game! 🎉",
 
  // FAQ
  htu_faq_title: "Frequently Asked Questions",
  htu_faq1_q: "Can I play online multiplayer?",
  htu_faq1_a: "No. This is an offline shared account. You can only play in single-player or offline modes.",
  htu_faq2_q: "Do I need internet to play?",
  htu_faq2_a: "You need internet once to download and install. After that, you play completely offline.",
  htu_faq3_q: "What if Steam asks for a verification code?",
  htu_faq3_a: "Contact us immediately via Support Chat. We will help you resolve it quickly.",
  htu_faq4_q: "Can I use the account on multiple devices?",
  htu_faq4_a: "No. The account is assigned to you only. Using it on multiple devices may cause issues.",
  htu_faq5_q: "What if I forget my credentials?",
  htu_faq5_a: "Log into PhsarGame and go to My Orders → View Credentials. They're always saved there.",
  htu_faq6_q: "Which payment apps work with KHQR?",
  htu_faq6_a: "ABA Mobile, ACLEDA Mobile, Wing, True Money, Pi Pay, and any Bakong-supported banking app.",
  htu_faq7_q: "How long does delivery take?",
  htu_faq7_a: "Delivery is instant — within seconds after your payment is confirmed by Bakong.",
 
  // Videos
  htu_videos_tag:   "Video Tutorials",
  htu_videos_title: "Watch & Learn",
  htu_vid1_title:   "How to Buy a Game",
  htu_vid1_sub:     "Step-by-step purchase guide",
  htu_vid2_title:   "How to Install & Play",
  htu_vid2_sub:     "Install Steam and go offline",
 
  // CTA
  htu_cta_title: "Ready to Play?",
  htu_cta_sub:   "Browse our catalog and get your game instantly. Pay with KHQR — ABA, ACLEDA, Wing and more.",
  },

  km: {
    // Navbar
    nav_home: "ទំព័រដើម",
    nav_store: "ហាងlauncher",
    nav_how: "របៀបប្រើ",
    nav_orders: "ការបញ្ជាទិញ",
    nav_login: "ចូល",
    nav_started: "ចាប់ផ្តើម",
    nav_signout: "ចាកចេញ",
    nav_admin: "ផ្ទាំងអ្នកគ្រប់គ្រង",

    // Home
    hero_eyebrow: "ហាង Game លេខ ១ ក្នុងប្រទេសកម្ពុជា",
    hero_title: "ហ្គេមល្អ",
    hero_accent: "តម្លៃទាប",
    hero_sub: "លេងហ្គេម AAA ជាមួយ Steam Shared Account។ ទទួលភ្លាម។ លេង Offline។ តម្លៃចាប់ពី $2.99 USD។ បង់ប្រាក់ Bakong KHQR។",
    hero_browse: "រកហ្គេម →",
    hero_how: "របៀបប្រើ",
    stat_games: "ហ្គេមទាំងអស់",
    stat_customers: "អ្នកទិញសប្បាយ",
    stat_price: "តម្លៃទាបបំផុត",
    stat_support: "ជំនួយ",
    section_why: "ហេតុអ្វីជ្រើស Phsar Game",
    section_everything: "គ្រប់អ្វីដែលត្រូវការ",
    section_everything_sub: "ងាយ រហ័ស ហើយថោក សម្រាប់លេង Game ល្អៗក្នុងប្រទេសកម្ពុជា។",
    feat_instant: "ទទួលភ្លាម",
    feat_instant_desc: "ទទួល Steam Account ភ្លាមបន្ទាប់ពីបង់ប្រាក់។ មិនចាំបាច់រង់ចាំ។",
    feat_offline: "លេង Offline",
    feat_offline_desc: "លេងហ្គេម Steam Offline mode គ្រប់ពេល។ មិនត្រូវការ Internet ពេលលេង។",
    feat_price: "ថោកបំផុតក្នុង KH",
    feat_price_desc: " សន្សំ 90% ធៀបនឹងតម្លៃ Steam ជាក់លាក់។ ហ្គេមល្អ តម្លៃទាប។",
    feat_support: "ជំនួយ 24/7",
    feat_support_desc: "មានបញ្ហា? ក្រុមជំនួយរបស់យើងរៀបចំហើយ ជួយតាម Live Chat។",
    section_featured: "ហ្គេមពិសេស",
    section_featured_tag: "ជម្រើសល្អ",
    section_featured_sub: "ហ្គេម AAA ជ្រើសសរ តម្លៃល្អបំផុត។ ទាំងអស់លេង Offline បាន។",
    view_all: "មើលហ្គេមទាំងអស់ →",
    how_title: "របៀបប្រើ",
    how_tag: "ដំណើរការងាយ",
    how_sub: "ចាប់ផ្តើម 4 ជំហាន ងាយ។ ត្រឹមតែ 5 នាទី។",
    step1_title: "រក & ទិញ",
    step1_desc: "ជ្រើសហ្គេម ហើយបង់ Bakong KHQR ដោយសុវត្ថិភាព។",
    step2_title: "ទទួល Account",
    step2_desc: "ទទួល Steam Email & Password ភ្លាម។",
    step3_title: "Install & Offline",
    step3_desc: "Login Steam, Install ហ្គេម ហើយប្ដូរ Offline Mode។",
    step4_title: "លេងគ្មានទីបញ្ចប់",
    step4_desc: "ប្ដូរ Account ខ្លួនឯង លេង Offline Mode។ គ្មានដែន។",
    cta_title: "ត្រៀមចាប់ផ្តើមលេង?",
    cta_desc: "ចូលរួមជាមួយ Gamer ខ្មែររាប់រយ ដែលកំពុងសន្សំ Steam Game។ បង់ ABA, ACLEDA, Wing ជាដើម។",
    cta_btn: "រកហ្គេម →",
    footer_copy: "Steam Shared Accounts · ប្រទេសកម្ពុជា",
    footer_note: "សម្រាប់ Offline Gaming ប៉ុណ្ណោះ។ មិនមែន Valve Corporation ផ្លូវការ។",

    // Store
    store_title: "ហាង Game",
    store_sub: "ហ្គេម",
    search_placeholder: "ស្វែងរកហ្គេម...",
    sort_newest: "ថ្មីបំផុត",
    sort_price_asc: "តម្លៃ ↑",
    sort_price_desc: "តម្លៃ ↓",
    sort_rating: "ពិន្ទុខ្ពស់",
    sort_name: "A → Z",
    filter_instock: "មានស្ដុក",
    no_games: "រកមិនឃើញហ្គេម",
    no_games_sub: "សាកប្ដូរ Filter ឬ ពាក្យស្វែងរក។",
    account_type: "ប្រភេទ Account",
    all_types: "ទាំងអស់",

    // Game Detail
    about_game: "អំពីហ្គេម",
    whats_included: "អ្វីខ្លះដែលបានរួម",
    how_works: "របៀបប្រើ",
    instant_delivery: "ទទួលភ្លាម",
    offline_access: "Offline Access",
    full_access: "ប្រើហ្គេមពេញ",
    support_chat: "ជំនួយ Chat",
    permanent: "ប្រើបានជានិច្ច",
    cambodia: "ប្រទេសកម្ពុជា",
    buy_now: "ទិញឥឡូវ →",
    out_of_stock: "អស់ស្ដុក",
    secured: "🔒 ធានាដោយ Bakong · NBC Cambodia",
    delivery_label: "ការដឹកជញ្ជូន",
    delivery_val: "⚡ ភ្លាម",
    type_label: "ប្រភេទ",
    stock_label: "ស្ដុក",
    payment_label: "ការបង់ប្រាក់",
    in_stock: "✅ មាន",
    back_store: "← ត្រឡប់ហាង",

    // Orders
    orders_title: "ការបញ្ជាទិញ",
    orders_all: "ទាំងអស់",
    orders_delivered: "ទទួលបាន",
    orders_pending: "រង់ចាំ",
    orders_expired: "ផុតកំណត់",
    no_orders: "មិនទាន់មានការបញ្ជាទិញ",
    no_orders_sub: "រកហ្គេម ហើយទិញដំបូង!",
    view_creds: "🔑 មើល Account",
    complete_pay: "💳 បញ្ចប់ការបង់ប្រាក់",
    support_chat_btn: "💬 ជំនួយ Chat",
    view_game: "🎮 មើលហ្គេម",

    // Chat
    chat_support: "ជំនួយ Phsar Game",
    chat_online: "អនឡាញ",
    chat_placeholder: "វាយសារ...",
    chat_hint: "Enter ដើម្បីផ្ញើ · Shift+Enter ឡើងជួរថ្មី",
    chat_empty_title: "ចាប់ផ្តើមការសន្ទនា",
    chat_empty_sub: "សួរយើងពីការបញ្ជាទិញ។\nតាម Rule ទូទៅ ចាំបំផុត 5 នាទី។",

    // Auth
    login_title: "ស្វាគមន៍",
    login_sub: "ចូល Phsar Game Account",
    login_email: "Email",
    login_password: "ពាក្យសម្ងាត់",
    login_btn: "ចូល",
    login_google: "បន្តជាមួយ Google",
    login_no_account: "មិនទាន់មាន Account?",
    login_register: "ចុះឈ្មោះ",
    register_title: "បង្កើត Account",
    register_sub: "ចូលរួម Phsar Game ថ្ងៃនេះ",
    register_name: "ឈ្មោះ",
    register_btn: "បង្កើត Account",
    register_have_account: "មាន Account ហើយ?",
    register_login: "ចូល",

    // Account types
    acc_steam: "Steam",
    acc_epic: "Epic Games",
    acc_game_account: "Game Account",
    acc_shared: "Shared Offline",
    acc_private: "Private Account",
    acc_family: "Family Share",

    // Status
    status_delivered: "ទទួលបាន",
    status_processing: "កំពុងដំណើរការ",
    status_pending: "រង់ចាំ",
    status_expired: "ផុតកំណត់",
    status_failed: "បរាជ័យ",

    // Floating chat
    float_chat_title: "ជំនួយផ្ទាល់",
    float_chat_sub: "ឆ្លើយក្នុង 5 នាទី",
    float_new_msg: "សាររបស់ថ្មី",

    // Check out
    co_order_summary:   "សង្ខេបការបញ្ជាទិញ",
  co_total:           "សរុប",
  co_powered_by:      "គាំទ្រដោយ",
  co_only:            "នៅសល់តែ",
  co_left:            "ប៉ុណ្ណោះ",
  co_available:       "មាន",
 
  co_secure_checkout: "ទូទាត់សុវត្ថិភាព",
  co_scan_to_pay:     "Scan ដើម្បីបង់",
  co_expired_title:   "QR Code ផុតកំណត់",
  co_error_title:     "កំហុសការបង់ប្រាក់",
 
  co_generating_qr:   "កំពុងបង្កើត QR Code",
  co_pay_now:         "បង់ប្រាក់ឥឡូវ",
  co_secured_by:      "ធានាដោយ ABA Bank Cambodia",
 
  co_scan_with:       "Scan ជាមួយ",
  co_or_banking:      "ឬ Application ធនាគារដែលគាំទ្រ",
  co_amount:          "ចំនួនទឹកប្រាក់",
  co_open_aba:        "បើក ABA Mobile App",
 
  co_poll_waiting:    "កំពុងរង់ចាំការបង់ប្រាក់",
  co_poll_confirmed:  "បញ្ជាក់ការបង់ប្រាក់! កំពុងផ្ញើ Account...",
 
  co_expired_desc:    "QR Code ផុតកំណត់ (15 នាទី).\nបង្កើតថ្មីដើម្បីបន្ត។",
  co_new_qr:          "បង្កើត QR Code ថ្មី",
 
  co_generic_error:   "មានបញ្ហាកើតឡើង។ សូមព្យាយាមម្ដងទៀត។",
  co_try_again:       "ព្យាយាមម្ដងទៀត",
  co_out_of_stock_err:"សុំទោស! ហ្គេមនេះអស់ស្ដុកហើយ!",
  co_unavailable:     "ហ្គេមនេះមិនអាចប្រើបាន។",
  co_load_fail:       "មិនអាចផ្ទុកព័ត៌មានហ្គេម។",
  co_pay_fail:        "ការចាប់ផ្ដើមបង់ប្រាក់បរាជ័យ។",

  // How to use
  // Hero
  htu_tag:          "មគ្គុទ្ទេសក៍រហ័ស",
  htu_title:        "របៀប",
  htu_title_accent: "ចាប់ផ្តើម",
  htu_sub:          "អនុវត្តតាម 7 ជំហានងាយៗ ដើម្បីចាប់ផ្តើមលេងហ្គេមមិនដល់ 10 នាទី។",
 
  // Step 1
  htu_s1_title: "រក & ទិញ",
  htu_s1_desc:  "ទៅ Store, ជ្រើសហ្គេម ហើយចុច Buy Now.",
  htu_s1_d1:    "ហ្គេមទាំងអស់អាចប្រើ Steam Offline បាន",
  htu_s1_d2:    "តម្លៃចាប់ពី $2.99 USD",
  htu_s1_d3:    "បង់ប្រាក់ Bakong KHQR (ABA, ACLEDA, Wing ជាដើម)",
 
  // Step 2
  htu_s2_title: "Scan KHQR ដើម្បីបង់",
  htu_s2_desc:  "QR Code នឹងបង្ហាញ។ បើក App ធនាគារ ហើយ Scan.",
  htu_s2_d1:    "ប្រើបានជាមួយ ABA, ACLEDA, Wing, True Money, Pi Pay ជាដើម",
  htu_s2_d2:    "ដំណើរការភ្លាម ដោយ Bakong (ធនាគារជាតិ)",
  htu_s2_d3:    "QR Code មានសុពលភាព 15 នាទី",
 
  // Step 3
  htu_s3_title: "ទទួល Account",
  htu_s3_desc:  "បន្ទាប់ពីបញ្ជាក់ការបង់ប្រាក់ ព័ត៌មាន Steam Account នឹងបង្ហាញភ្លាម។",
  htu_s3_d1:    "Steam Email និង Password បង្ហាញនៅអេក្រង់",
  htu_s3_d2:    "ផ្ញើទៅ Email ដែលចុះឈ្មោះផងដែរ",
  htu_s3_d3:    "រក្សាទុក Credentials ដោយប្រុងប្រយ័ត្ន!",
 
  // Step 4
  htu_s4_title: "Login ចូល Steam",
  htu_s4_desc:  'បើក Steam ហើយចុច "Sign in to a different account"។ បញ្ចូល Credentials ដែលបានផ្តល់។',
  htu_s4_d1:    "Download Steam ពី store.steampowered.com បើចាំបាច់",
  htu_s4_d2:    "ប្រើ Credentials ដូចដែលបានផ្តល់ — មិនត្រូវកែប្រែ",
  htu_s4_d3:    "បើ Steam សុំ Verification Code សូមទំនាក់ទំនង Support",
 
  // Step 5
  htu_s5_title: "Install ហ្គេម",
  htu_s5_desc:  "ទៅ Library, រកហ្គេម ហើយចុច Install.",
  htu_s5_d1:    "ត្រូវប្រាកដថាមាន Disk Space គ្រប់គ្រាន់",
  htu_s5_d2:    "ល្បឿន Download អាស្រ័យលើ Internet",
  htu_s5_d3:    "Install តែម្តង ហើយប្រើបានរហូត",
 
  // Step 6
  htu_s6_title: "ប្ដូរទៅ Offline Mode",
  htu_s6_desc:  'ទៅ Steam Menu (ជ្រុងខាងឆ្វេង) → ចុច "Go Offline"។ Steam នឹង Restart.',
  htu_s6_d1:    "ចុច Steam នៅជ្រុងខាងឆ្វេង",
  htu_s6_d2:    'ជ្រើស "Go Offline…" ពី Dropdown',
  htu_s6_d3:    "Steam នឹង Restart — ធម្មតា",
 
  // Step 7
  htu_s7_title: "លេងបាន!",
  htu_s7_desc:  "បើកហ្គេមពី Library ហើយចូល Steam Account ខ្លួនឯង លេង Offline!",
  htu_s7_d1:    "ហ្គេម Start ក្នុង Offline Mode",
  htu_s7_d2:    "ប្ដូរទៅ Steam Account ផ្ទាល់ខ្លួន",
  htu_s7_d3:    "រីករាយជាមួយហ្គេម! 🎉",
 
  // FAQ
  htu_faq_title: "សំណួរដែលសួរញឹកញាប់",
  htu_faq1_q: "អាចលេង Online Multiplayer បានទេ?",
  htu_faq1_a: "អត់។ នេះជា Offline Shared Account។ អាចលេងតែ Single-player ឬ Offline Mode ប៉ុណ្ណោះ។",
  htu_faq2_q: "ត្រូវការ Internet ពេលលេងទេ?",
  htu_faq2_a: "ត្រូវការ Internet ម្តង ដើម្បី Download Install ហ្គេម។ បន្ទាប់មកលេង Offline ទាំងស្រុងបាន។",
  htu_faq3_q: "បើ Steam សុំ Verification Code ធ្វើម៉េច?",
  htu_faq3_a: "ទំនាក់ទំនង Support Chat ភ្លាម។ យើងនឹងជួយដោះស្រាយឱ្យបានរហ័ស។",
  htu_faq4_q: "អាចប្រើ Account នៅលើឧបករណ៍ច្រើនទេ?",
  htu_faq4_a: "អត់។ Account ត្រូវបានកំណត់សម្រាប់អ្នកតែម្នាក់។ ប្រើលើឧបករណ៍ច្រើនអាចបណ្ដាលឱ្យមានបញ្ហា។",
  htu_faq5_q: "បើភ្លេច Credentials ធ្វើម៉េច?",
  htu_faq5_a: "Login ចូល PhsarGame ហើយទៅ My Orders → View Credentials។ វានៅទីនោះជានិច្ច។",
  htu_faq6_q: "App ធនាគារណាខ្លះដែលប្រើ KHQR បាន?",
  htu_faq6_a: "ABA Mobile, ACLEDA Mobile, Wing, True Money, Pi Pay ហើយនិង App ធនាគារដែលគាំទ្រ Bakong ទាំងអស់។",
  htu_faq7_q: "ការ Delivery ចំណាយពេលប៉ុន្មាន?",
  htu_faq7_a: "Delivery ភ្លាម — ក្នុងរយៈពេលប៉ុន្មានវិនាទីបន្ទាប់ពី Bakong បញ្ជាក់ការបង់ប្រាក់។",
 
  // Videos
  htu_videos_tag:   "វីដេអូណែនាំ",
  htu_videos_title: "មើល & រៀន",
  htu_vid1_title:   "របៀបទិញហ្គេម",
  htu_vid1_sub:     "មគ្គុទ្ទេសក៍ការទិញជំហានម្តងៗ",
  htu_vid2_title:   "របៀប Install & លេង",
  htu_vid2_sub:     "Install Steam ហើយប្ដូរ Offline",
 
  // CTA
  htu_cta_title: "ត្រៀមលេងហ្គេមហើយ?",
  htu_cta_sub:   "រកហ្គេម ហើយទទួលភ្លាម។ បង់ KHQR — ABA, ACLEDA, Wing ជាដើម។",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pg_lang") || "en");

  useEffect(() => {
    localStorage.setItem("pg_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => translations[lang]?.[key] ?? translations.en[key] ?? key;

  const toggleLang = () => setLang((l) => (l === "en" ? "km" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
}